<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="车辆类型" prop="planType">
              {{ planTypeMap.get(formData.planType) || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.planType === '2'">
            <el-form-item label="是否油轮" prop="isOiltanker">
              {{ formData.isOiltanker === '1' ? '是' : '否' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌号" prop="vehicleKey">
              {{ formData.vehicleKey }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="挂车号" prop="vehicleGph">
              {{ formData.vehicleGph }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机姓名" prop="driverName">
              {{ formData.driverName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机身份证" prop="driverKey">
              {{ formData.driverKey }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机手机号" prop="driverMobile">
              {{ formData.driverMobile }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机照片" prop="driverPhotoUrl">
              <el-image v-if="formData.driverPhotoUrl" :src="formData.driverPhotoUrl"
                :preview-src-list="[formData.driverPhotoUrl]" fit="cover" style="width: 100px; height: 100px" />
              <span v-else>暂无照片</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="附件" prop="fileList">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { planType } from '@/utils/dict'

export default {
  name: 'CarManageDetail',
  data() {
    return {
      planTypeMap: planType,
      formData: {
        vehicleKey: '', // 车牌号
        vehicleGph: '', // 挂车号
        driverName: '', // 司机姓名
        isOiltanker: '', // 是否油轮
        driverKey: '', // 司机身份证
        driverMobile: '', // 司机手机号
        fileList: [] // 附件列表
      }
    }
  },
  computed: {
    vehicleId() {
      return this.$route.query.vehicleId
    }
  },
  created() {
    if (this.vehicleId) {
      this.loadDetails()
    }
  },
  methods: {
    loadDetails() {
      this.$axios.get(this.$apis.carManage.selectWlVehicleInfoByVehicleId, {
        params: { vehicleId: this.vehicleId }
      }).then(res => {
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
